import update from 'immutability-helper'
import * as actions from '../actions/formSubmissions'

const INITIAL_STATE = {
  submissions: [],
  currentSubmission: null,
}

export default function formSubmissionsReducer(state = INITIAL_STATE, action) {
  var index = -1
  var updatedSubmission = {}

  switch (action.type) {
    case actions.GET_FORM_SUBMISSIONS_SUCCESS:
      return {
        ...state,
        submissions: action.submissions,
      }

    case actions.GET_FORM_SUBMISSION_SUCCESS:
      // Also update the submission in the list to reflect viewed status
      var updatedSubmissions = state.submissions.map(function (sub) {
        if (sub.id === action.submission.id) {
          return Object.assign({}, sub, {
            recipientViewed: action.submission.recipientViewed,
          })
        }
        return sub
      })

      return {
        ...state,
        submissions: updatedSubmissions,
        currentSubmission: action.submission,
      }

    case actions.CLEAR_CURRENT_SUBMISSION:
      return {
        ...state,
        currentSubmission: null,
      }

    case actions.MARK_SUBMISSION_VIEWED:
      // Optimistically mark submission as viewed in the list
      var viewedSubmissions = state.submissions.map(function (sub) {
        if (sub.id === action.submissionId) {
          var newRecipientViewed = Object.assign(
            {},
            sub.recipientViewed || {},
            { [action.userEmail]: new Date().toISOString() },
          )
          return Object.assign({}, sub, { recipientViewed: newRecipientViewed })
        }
        return sub
      })

      return {
        ...state,
        submissions: viewedSubmissions,
      }

    case actions.MARK_SUBMISSION_UNREAD_SUCCESS:
      // Mark submission as unread by removing user's viewed timestamp
      var unreadSubmissions = state.submissions.map(function (sub) {
        if (sub.id === action.submissionId) {
          var newRecipientViewed = Object.assign({}, sub.recipientViewed || {})
          delete newRecipientViewed[action.userEmail]
          return Object.assign({}, sub, { recipientViewed: newRecipientViewed })
        }
        return sub
      })

      // Also update currentSubmission if it matches
      var newCurrentSubmission = state.currentSubmission
      if (
        state.currentSubmission &&
        state.currentSubmission.id === action.submissionId
      ) {
        var currentRecipientViewed = Object.assign(
          {},
          state.currentSubmission.recipientViewed || {},
        )
        delete currentRecipientViewed[action.userEmail]
        newCurrentSubmission = Object.assign({}, state.currentSubmission, {
          recipientViewed: currentRecipientViewed,
        })
      }

      return {
        ...state,
        submissions: unreadSubmissions,
        currentSubmission: newCurrentSubmission,
      }

    case actions.UPDATE_SUBMISSION_STATUS_SUCCESS:
      // Update in submissions list
      state.submissions.forEach(function (sub, idx) {
        if (sub.id === action.submissionId) index = idx
      })

      if (index >= 0) {
        updatedSubmission = Object.assign({}, state.submissions[index], {
          currentStatus: action.newStatus,
        })
        var newState = update(state, {
          submissions: {
            $splice: [[index, 1, updatedSubmission]],
          },
        })

        // Also update current submission if it matches
        if (
          state.currentSubmission &&
          state.currentSubmission.id === action.submissionId
        ) {
          var currentHistory = state.currentSubmission.statusHistory || []
          newState = update(newState, {
            currentSubmission: {
              currentStatus: { $set: action.newStatus },
              statusHistory: {
                $set: currentHistory.concat([action.statusHistoryEntry]),
              },
            },
          })
        }

        return newState
      }

      // If not in list but is current submission, still update
      if (
        state.currentSubmission &&
        state.currentSubmission.id === action.submissionId
      ) {
        var existingHistory = state.currentSubmission.statusHistory || []
        return update(state, {
          currentSubmission: {
            currentStatus: { $set: action.newStatus },
            statusHistory: {
              $set: existingHistory.concat([action.statusHistoryEntry]),
            },
          },
        })
      }

      return state

    case actions.ADD_SUBMISSION_COMMENT_SUCCESS:
      // Add comment to current submission if it matches
      if (
        state.currentSubmission &&
        state.currentSubmission.id === action.submissionId
      ) {
        return update(state, {
          currentSubmission: {
            comments: { $push: [action.comment] },
          },
        })
      }
      return state

    case actions.UPDATE_SUBMISSION_COMMENT_SUCCESS:
      // Update comment in current submission if it matches
      if (
        state.currentSubmission &&
        state.currentSubmission.id === action.submissionId
      ) {
        var updatedComments = state.currentSubmission.comments.map(
          function (c) {
            if (c.id === action.commentId) {
              return action.comment
            }
            return c
          },
        )
        return update(state, {
          currentSubmission: {
            comments: { $set: updatedComments },
          },
        })
      }
      return state

    case actions.DELETE_SUBMISSION_FOR_ALL_SUCCESS:
    case actions.DELETE_SUBMISSION_FOR_USER_SUCCESS:
      // Remove from submissions list
      var filteredSubmissions = state.submissions.filter(function (sub) {
        return sub.id !== action.submissionId
      })

      // Clear current submission if it was deleted
      var newCurrentSubmission = state.currentSubmission
      if (
        state.currentSubmission &&
        state.currentSubmission.id === action.submissionId
      ) {
        newCurrentSubmission = null
      }

      return {
        ...state,
        submissions: filteredSubmissions,
        currentSubmission: newCurrentSubmission,
      }

    default:
      return state
  }
}
